import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import KsAsigFechaTabla from '../../../Component/Grupo1/KsAsigFechaTabla'


function KsAsFecha() {
  

  return (
      <div className="g1_wrapper">
        <div className="g1_body_alt">
      <KsAsigFechaTabla/>
      </div>
        
      </div>
  );
}

export default KsAsFecha;